import { NewHandSummaryJson, HandSummaryActionWithPlayerId } from './BuddyPage';

// Define standard position order for convenience
const POSITION_ORDER_9_HANDED = ['SB', 'BB', 'UTG', 'UTG+1', 'MP', 'LJ', 'HJ', 'CO', 'BTN'] as const;

// Mock data for the visualiser/replayer - UPDATED FOR FULL TABLE LIMP
export const mockHandData: NewHandSummaryJson = {
  metadata: {
    handId: 'mockLimpHand456',
    stakes: { smallBlind: 50, bigBlind: 100 }, // Updated stakes
    timestamp: new Date().toISOString(),
    handType: 'Online',
    tableType: 'Cash Game',
  },
  players: POSITION_ORDER_9_HANDED.map((pos, index) => ({
    id: index + 1, // Assign sequential IDs
    name: pos === 'LJ' ? 'Hero' : `Player ${index + 1} (${pos})`,
    initialStack: 10000, // 100 BB stack
    position: pos,
    isHero: pos === 'LJ', // Set Hero to LJ
  })),
  heroCards: { holeCard1: 'Ad', holeCard2: 'Kd' }, // Hero (LJ) gets Ad Kd
  preflop: {
    potSizeAtStart: 150, // SB + BB
    potSizeAtEnd: 900, // 9 players * 100 (Big Blind)
    actions: [
      // Implicit SB post (handled by stake definition? Or add action?)
      // Implicit BB post (handled by stake definition?)
      // Let's assume blinds are posted implicitly and actions start from UTG
      // Note: getPlayerDataForRender needs to handle initial blind deduction accurately
      { playerId: 3, type: 'Call', amount: 100 }, // UTG calls 100
      { playerId: 4, type: 'Call', amount: 100 }, // UTG+1 calls 100
      { playerId: 5, type: 'Call', amount: 100 }, // MP calls 100
      { playerId: 6, type: 'Call', amount: 100 }, // LJ (Hero) calls 100
      { playerId: 7, type: 'Call', amount: 100 }, // HJ calls 100
      { playerId: 8, type: 'Call', amount: 100 }, // CO calls 100
      { playerId: 9, type: 'Call', amount: 100 }, // BTN calls 100
      { playerId: 1, type: 'Call', amount: 50 },  // SB calls 50 (already posted 50)
      { playerId: 2, type: 'Check' }, // BB checks (already posted 100)
    ] as HandSummaryActionWithPlayerId[], // Ensure correct type
  },
  flop: {
    potSizeAtStart: 900,
    potSizeAtEnd: 900, // No action yet
    cardsDealt: ['7s', '8s', '9h'], // Example flop
    actions: [], // No flop actions yet
  },
  turn: {
    potSizeAtStart: 900,
    potSizeAtEnd: 900,
    cardsDealt: ['Ts'], // Example turn
    actions: [], // No turn actions yet
  },
  river: {
    potSizeAtStart: 900,
    potSizeAtEnd: 900,
    cardsDealt: ['2c'], // Example river
    actions: [], // No river actions yet
  },
  finalPot: 900, // Final pot after preflop limps
  // Showdown details omitted for this example
}; 